'use client';
import { createProps, splitProps } from '@chakra-ui/utils';

const editableProps = createProps()([
  "defaultValue",
  "finalFocusRef",
  "isDisabled",
  "isPreviewFocusable",
  "onBlur",
  "onCancel",
  "onChange",
  "onEdit",
  "onSubmit",
  "placeholder",
  "selectAllOnFocus",
  "startWithEditView",
  "submitOnBlur",
  "value"
]);
const splitEditableProps = (props) => {
  return splitProps(props, editableProps);
};

export { editableProps, splitEditableProps };
